import React from "react";
import CookieBotDeclarations from "../../components/CookieBot/Declarations";
import { createReplacer } from "./Replacer";

const replaceCookieDeclaration = createReplacer({
  supports({ attribs, name }) {
    return (
      name === "span" && attribs?.["data-replacer"] === "CookieDeclaration"
    );
  },
  replace() {
    return <CookieBotDeclarations id={process.env.GATSBY_COOKIEBOT_ID} />;
  },
});

export default replaceCookieDeclaration;
